import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('IdCode')
export class IdCode {
  @JsonProperty('id', Number) id: number = undefined;
  @JsonProperty('code', String) code: string = undefined;
}